import React from "react";
import { Chip } from "primereact/chip";
import Spinner from "./Spinner";
import { FaChevronRight } from "react-icons/fa6";
import { useTranslation } from "react-i18next";

const chipTypeClasses = {
  primary: {
    base: "rounded-full !py-1 !px-3 !text-[12px] !bg-primary text-white capitalize",
  },
  secondary: {
    base: "rounded-full !py-1 !px-3 !text-[12px] !bg-gray-500 text-white capitalize",
  },
  success: {
    base: "rounded-full !py-1 !px-3 !text-[12px] !bg-success text-white capitalize",
  },
  danger: {
    base: "rounded-full !py-1 !px-3 !text-[12px] !bg-red-500 text-white capitalize",
  },
  warning: {
    base: "rounded-full !py-1 !px-3 !text-[12px] !bg-yellow-500 text-white capitalize",
  },
  blue: {
    base: "rounded-full !py-1 !px-3 !text-[12px] !bg-blue text-white capitalize",
  },
  gradient: {
    base: "rounded-full !py-1 !px-3 !text-[12px] !bg-gradient text-white capitalize border-primary !outline-none !shadow-none",
  },

  "mono-dark": {
    base: "rounded-full !h-[22px] !py-0 !px-3 !text-[11px] !bg-gray-800 text-white capitalize font-medium flex items-center justify-center transition-all",
  },
  "mono-light": {
    base: "rounded-full !h-[22px] !py-0 !px-3 !text-[11px]  text-gray-500 capitalize font-medium border border-gray-200 flex items-center justify-center transition-all",
  },
  "mono-outline": {
    base: "rounded-full !h-[22px] !py-0 !px-3 !text-[11px]  text-gray-400 border border-gray-200 capitalize font-medium flex items-center justify-center transition-all",
  },

  file: {
    base: "rounded-md !py-2 !px-3 !text-[14px] !bg-gray-200  text-gray-400 !font-semibold capitalize border-primary !outline-none !shadow-none",
  },
  default: {
    base: "rounded-full !py-1 !px-3 !text-[12px] bg-gray-400 text-white capitalize",
  },
};

const CustomChip = ({
  label = "",
  title = "",
  icon = "",
  chipType = "default",
  className = "",
  onClick,
  removable = false,
  loading = false,
  labelClassName = "",
  onRemove,
  showActionIcon = false,
  ...props
}) => {
  const { base } = chipTypeClasses[chipType] || chipTypeClasses.default;

  const isClickable = !!onClick;
  const { t, i18n } = useTranslation()
  return (
    <Chip
      title={title}
      label={
        <div className="flex items-center gap-1.5">
          {loading ? <Spinner /> : t(label)}
          {showActionIcon && !loading && (
            <FaChevronRight size={8} className={`text-gray-400 ${i18n.language === "ar" ? "rotate-180" : ""}`} />
          )}
        </div>
      }
      icon={loading ? "" : icon}
      removable={removable}
      className={` ${base} ${className} ${isClickable ? "cursor-pointer active:scale-95" : "cursor-default opacity-90"} `}
      onClick={onClick}
      onRemove={onRemove}
      pt={{
        label: { className: `pl-1 ${labelClassName}` },
      }}
      {...props}
    />
  );
};

export default CustomChip;
